var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { SHUFFLE_SVG } from "../../assets";
import { ListView, Box } from "..";
import { displayDate } from "../..";
import { messages } from '../../messages';
import YouTube from 'react-youtube';
var CuratedDetail = /** @class */ (function (_super) {
    __extends(CuratedDetail, _super);
    function CuratedDetail() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CuratedDetail.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, set = _b.set, hideUpdated = _b.hideUpdated;
        return React.createElement(Box, { style: { padding: '40px', minHeight: '50vh' } },
            React.createElement("div", { className: "curated-detail" },
                React.createElement("div", { className: "curated-row" },
                    React.createElement("div", { className: "curated-img" },
                        React.createElement("div", { className: "set-img" },
                            React.createElement("img", { src: set.image_url })),
                        React.createElement("div", { className: "set-info-wrapper" },
                            React.createElement("div", { className: "set-info" },
                                set.albums.length,
                                " Songs"),
                            React.createElement("div", { className: "set-shuffle", onClick: function () {
                                    _this.listView && _this.listView.play(true);
                                } },
                                React.createElement("div", null,
                                    messages.Shuffle,
                                    " ",
                                    React.createElement("img", { src: SHUFFLE_SVG, width: 15 })))),
                        React.createElement("div", { className: 'set-curator-right' },
                            "Curated by:",
                            React.createElement("span", { className: "curator-name" }, set.curator)),
                        !hideUpdated && React.createElement("div", { className: "set-updated" },
                            set.is_generated && 'Updated Daily',
                            !set.is_generated && "Updated " + displayDate(set.updated_at)),
                        React.createElement("div", { className: "set-description" }, set.description),
                        set.youtube_url &&
                            React.createElement("div", { className: "set-video-wrapper" },
                                React.createElement("div", { className: "video-title" }, "Watch the Mix:"),
                                set.youtube_url.startsWith('https://www.youtube') &&
                                    React.createElement(YouTube, { containerClassName: 'vod-youtube', opts: {
                                            playerVars: {
                                                autoplay: 0,
                                                modestbranding: 1,
                                                controls: 0,
                                            },
                                            height: '100%',
                                            width: '100%',
                                        }, videoId: (set.youtube_url.split('v=')[1] || '').split('&')[0], onPlay: function () {
                                            _this.props.onVideoClick && _this.props.onVideoClick();
                                        } })),
                        this.props.related && this.props.related.length > 0 ?
                            React.createElement("div", { className: "set-more-curated" },
                                React.createElement("div", { className: "more-curated-text" },
                                    "More Curated Sets from ", "" + set.curator),
                                React.createElement("div", { className: "related-sets-wrapper" }, (_a = this.props.related) === null || _a === void 0 ? void 0 : _a.map(function (relatedSet) {
                                    return (React.createElement("div", { className: "related-set", key: relatedSet.id },
                                        React.createElement("img", { className: "related-set-img", onClick: function () {
                                                _this.props.onCuratedSetClick &&
                                                    _this.props.onCuratedSetClick(relatedSet.slug);
                                            }, src: relatedSet.image_thumbnail_url })));
                                })))
                            : null),
                    React.createElement("div", { className: "curated-list" },
                        React.createElement(ListView, __assign({ ref: function (ref) { return _this.listView = ref; } }, this.props, { shareType: this.props.shareType, enableDrag: this.props.enableDrag, noBox: true, title: set.title, subTitle: set.curator, contentType: 'audio', albums: set.albums, context: 'curated-set', hide: { firstSeperator: false }, onAlbumSelected: this.props.onAlbumSelected, onArtistClick: this.props.onArtistClick, onMediaSelected: this.props.onMediaSelected, onMediaDownlod: this.props.onMediaDownlod, onAddToCrate: this.props.onAddToCrate, onRemoveFromCrate: this.props.onRemoveFromCrate }))))));
    };
    return CuratedDetail;
}(React.PureComponent));
export default CuratedDetail;
//# sourceMappingURL=CuratedDetail.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/components/views/CuratedDetail.js
// module id = 1299
// module chunks = 0